import styled from 'styled-components';

export const BuilderWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
`;
